import { useEffect, useRef, useState } from "react";
import { ReactComponent as CheckIcon } from "../../assets/icons/tick-icon.svg";
import useNotifyFisnishOnboarding from "../../modules/exit-loader/hooks/use-notify-finish-onboarding";
import ProfileUpdateScreen from "../../components/profile-update-screen/profile-update-screen";
import { isRnRUser } from "../../shared/utils/helpers";
import FullScreenLoader from "../../components/loader/full-screen-loader";
import { finishOnboarding } from "../../shared/appInterface";

const MAX_SCREEN_TIME = 2000;
const ExitLoader = () => {
    const timeOutRef = useRef<any>();
    const timerRef = useRef<any>();

    const [timeLeft, setTimeLeft] = useState(100);

    useEffect(() => {
        try {
            if (isRnRUser()) {
                timeOutRef.current = setTimeout(finishOnboarding, 1300);
                timerRef.current = setInterval(() => {
                    setTimeLeft((t) => {
                        if (t >= MAX_SCREEN_TIME) {
                            clearInterval(timerRef.current);
                        }
                        return t + 10;
                    });
                }, 10);
            } else {
                finishOnboarding();
            }
        } catch (error) {
            console.error("Failed to Exit");
        }

        return () => {
            if (isRnRUser()) {
                clearInterval(timerRef.current);
                clearTimeout(timeOutRef.current);
            }
        };
    }, []);

    const handleJobsClick = () => {
        clearTimeout(timeOutRef.current);
        finishOnboarding();
    };

    return (
        <>
            {isRnRUser() ? (
                <ProfileUpdateScreen onJobsClick={handleJobsClick} timeLeft={timeLeft} />
            ) : (
                <FullScreenLoader />
            )}
        </>
    );
};

export default ExitLoader;
